/* eslint-disable no-unused-expressions */
import {Power0, Power1} from 'gsap';

let svgScheme = '.chapter-position .chapter-fixed__figure.scheme-3 svg';
let scheme = document.querySelector(svgScheme);
let fullAnimation = null;

const play = () => {
	if (fullAnimation && fullAnimation.paused()) {
		fullAnimation.play();
	}
};

const pause = () => {
	if (fullAnimation && !fullAnimation.paused()) {
		fullAnimation.pause();
	}
};

const setStrokeDashoffset = (el) => {
	const path = el.getTotalLength();
	gsap.set(el, {
		strokeDashoffset: path,
		strokeDasharray: `${path}, ${path}`,
	});
};

const reset = () => {
	const tm = gsap.timeline();
	const highlightGropup = scheme.querySelectorAll('.highlight-group');
	const lines = scheme.querySelectorAll('.lines-group .lines');

	// vibration-sensor
	const parent = scheme.querySelector('.vibration-sensor');
	const vibrationCircle = parent.querySelectorAll('.vibration-sensor-circle');
	const vibrationSensor = parent.querySelectorAll('.vibration-sensor-figure');
	const rect = parent.querySelectorAll('.vibration-sensor-figure--rect--fill');
	const figureStroke = parent.querySelectorAll('.vibration-sensor-figure--stroke');

	const graphLineThird = scheme.querySelectorAll('.graph-3');
	const graphLines = scheme.querySelectorAll('.graph-lines');
	const graphOpacity = scheme.querySelectorAll('.graph-opacity');

	// setStrokeDashoffset(vibrationCircle);
	// setStrokeDashoffset(vibrationSensorCircle);

	vibrationSensor.forEach((element) => {
		const vibrationSensorCircle = element.querySelector('.vibration-sensor-figure-circle');
		setStrokeDashoffset(vibrationSensorCircle);
	});

	vibrationCircle.forEach((element) => {
		setStrokeDashoffset(element);
	});

	figureStroke.forEach((element) => {
		setStrokeDashoffset(element);
	});

	graphLineThird.forEach((element) => {
		const elFill = element.querySelector('.graph-fill');
		const elLine = element.querySelector('.graph-line');

		if (elLine) {
			setStrokeDashoffset(elLine);
		}

		tm
			.set(elFill, {
				autoAlpha: 0,
			});
	});
	tm
		.set(rect, {
			autoAlpha: 0,
		})

		.set(vibrationSensor, {
			scaleX: 0,
			scaleY: 0,
			x: 100,
			y: 100,
		});

	graphOpacity.forEach((element) => {
		const elPath = element.querySelector('.graph-opacity-path');
		const elFill = element.querySelector('.graph-opacity-path-fill');

		if (elFill) {
			tm
				.set(elFill, {
					autoAlpha: 0,
				});
		}
		tm
			.set(elPath, {
				autoAlpha: 0,
			});
	});
	graphLines.forEach((element) => {
		const elLine = element.querySelector('.graph--line');
		const elFill = element.querySelector('.graph--line-fill');
		setStrokeDashoffset(elLine);

		if (elFill) {
			setStrokeDashoffset(elFill);

			tm
				.set(elFill, {
					autoAlpha: 0,
				});
		}
	});
	lines.forEach((element) => {
		const defaultLine = element.querySelector('.lines-default');
		const gradientLine = element.querySelector('.lines-gradient');

		if (defaultLine) {
			setStrokeDashoffset(defaultLine);
		}

		if (gradientLine) {
			setStrokeDashoffset(gradientLine);

			tm
				.set(gradientLine, {
					autoAlpha: 0,
				});
		}
	});

	highlightGropup.forEach((element) => {
		const highlight = element.querySelector('.highlight-default');
		const highlightGradient = element.querySelector('.highlight-gradient');
		// const camera = element.querySelector('.highlight-group-camera-default');
		const gradientCamer = element.querySelector('.highlight-group-camera-gradiend');

		tm
			.set([highlight, highlightGradient, gradientCamer], {
				autoAlpha: 0,
			}, 0);
	});
};

const startAnimeProgressLine = () => {
	const lines = scheme.querySelectorAll('.lines-group .lines');
	lines.forEach((element) => {
		const tm = gsap.timeline();

		fullAnimation.add(tm.play(), 0);

		const defaultLine = element.querySelector('.lines-default');
		const gradientLine = element.querySelector('.lines-gradient');
		const time = 3.5;

		tm.to([defaultLine, gradientLine], {
			ease: Power0.easeInOut,
			strokeDashoffset: 0,
			duration: time,
			stagger: 0,
		}, 0);

		if (gradientLine) {
			tm.to(gradientLine, {
				autoAlpha: 1,
				duration: time,
				delay: 0.5,
				stagger: 0,
			}, 0);
		}
	});
};

const vibrationSensorAnimate = () => {
	const tm = gsap.timeline();
	const parent = scheme.querySelector('.vibration-sensor');
	const line = parent.querySelectorAll('.vibration-sensor-circle');
	const vibrationSensor = parent.querySelector('.vibration-sensor-figure');
	const vibrationSensorCircle = parent.querySelector('.vibration-sensor-figure-circle');
	const figureStroke = parent.querySelectorAll('.vibration-sensor-figure--stroke');
	const rect = parent.querySelectorAll('.vibration-sensor-figure--rect--fill');

	const time = 0.75;

	tm
		.to(line, {
			ease: Power0.easeInOut,
			strokeDashoffset: 0,
			duration: time,
		})
		.to(line, {
			ease: Power0.easeInOut,
			duration: time,
			stroke: '#E0A672',
		}, 1);

	tm
		.to(vibrationSensor, {
			scaleX: 1,
			scaleY: 1,
			x: 0,
			y: 0,
			duration: time,
		}, 0)
		.to(vibrationSensorCircle, {
			ease: Power0.easeInOut,
			strokeDashoffset: 0,
			duration: time,
		}, 0)
		.to(vibrationSensorCircle, {
			ease: Power0.easeInOut,
			stroke: '#E0A672',
			duration: time,
		}, time * 0.6)
		.to(figureStroke, {
			ease: Power0.easeInOut,
			strokeDashoffset: 0,
			duration: time,
			stagger: 0,
		}, 0)
		.to(figureStroke, {
			ease: Power0.easeInOut,
			stroke: '#E0A672',
			duration: time,
			stagger: 0,
		}, 1)
		.to(rect, {
			ease: Power0.easeInOut,
			duration: time,
			autoAlpha: 1,
		}, time * 0.3);
};

const highlightGropupAnimate = () => {
	const highlightGropup = scheme.querySelectorAll('.highlight-group');

	highlightGropup.forEach((element) => {
		const tm = gsap.timeline();

		fullAnimation.add(tm.play(), 0);

		const tmCamera = gsap.timeline();
		const highlight = element.querySelector('.highlight-default');
		const highlightGradient = element.querySelector('.highlight-gradient');
		const gradientCamera = element.querySelector('.highlight-group-camera-gradiend');
		const reactor = document.querySelector('.reactor');

		const time = 0.5;

		tm
			.to(highlight, {
				autoAlpha: 1,
				duration: time,
			}, 0)
			.to(highlightGradient, {
				autoAlpha: 1,
				duration: time,

				onComplete: () => {
					if (gradientCamera) {
						tmCamera
							.to(reactor, {
								autoAlpha: 0,
								duration: time,
							});
					}
				},
			}, time);

		if (gradientCamera) {
			tm.to(gradientCamera, {
				autoAlpha: 1,
				duration: time,
				onStart: () => {
					vibrationSensorAnimate();
				},
			}, time);
		}
	});
};

const graphLineAnimate = () => {
	const graphLine = scheme.querySelectorAll('.graph-3');

	graphLine.forEach((element, i) => {
		const tm = gsap.timeline({repeat: -1,
			yoyo: true});
		fullAnimation.add(tm.play(), 0);
		const elhLine = element.querySelector('.graph-line');
		const elbg = element.querySelector('.graph-fill');
		const time = 1.5;
		tm
			.to(elhLine, {
				ease: Power0.easeInOut,
				strokeDashoffset: 0,
				duration: time,
				stagger: 0,
			}, i * 2)
			.to(elhLine, {
				ease: Power0.easeInOut,
				duration: time,
				stagger: 0,
				stroke: '#E0A672',
			}, `${1 + i * 2}`)
			.to(elbg, {
				autoAlpha: 1,
				duration: time,
				stagger: 0,
			}, `${0.5 + i * 2}`);
	});
};

const graphOpacityAnimate = () => {
	const graphOpacity = scheme.querySelectorAll('.graph-opacity');

	graphOpacity.forEach((element, i) => {
		const tm = gsap.timeline({
			repeat: -1,
			yoyo: true,
		});

		fullAnimation.add(tm.play(), i);

		const path = element.querySelector('.graph-opacity-path');
		const fill = element.querySelector('.graph-opacity-path-fill');
		const time = 2;

		tm.to(path, {
			duration: time,
			ease: Power1.easeInOut,
			autoAlpha: 1,

			onReverseComplete: () => {
				tm.play();
			},
		});

		if (fill) {
			tm.to(fill, {
				duration: time,
				ease: Power1.easeInOut,
				autoAlpha: 1,
			}, time);
		}
	});
};

const graphAnimate = () => {
	const graphLine = scheme.querySelectorAll('.graph-lines');

	graphLine.forEach((element, i) => {
		const tm = gsap.timeline({
			repeat: -1,
			yoyo: true,
		});

		fullAnimation.add(tm.play(), i * 2);

		const elhLine = element.querySelector('.graph--line');
		const elhLineFill = element.querySelector('.graph--line-fill');

		tm.to([elhLine, elhLineFill], {
			ease: Power0.easeInOut,
			strokeDashoffset: 0,
			duration: 1.5,
			stagger: 0,
		}, 0);

		if (elhLineFill) {
			tm.to(elhLineFill, {
				autoAlpha: 1,
				duration: 1.5,
				stagger: 0,

			}, 0);
		}
	});
};

const create = () => {
	fullAnimation = gsap.timeline({paused: true});
	startAnimeProgressLine();
	graphLineAnimate();
	graphAnimate();
	highlightGropupAnimate();
	graphOpacityAnimate();
};

const init = () => {
	reset();
	create();
};

export default {
	init,
	reset,
	play,
	pause,
};
